const Logo = props => <img alt="Logo" src="/static/FMS.png" {...props} />

export default Logo
